module.exports = __webpack_public_path__ + "img/img77.1033fbe9.png";